/**
 * Builds the "Shared with …" copy used by the editor's sharing surfaces from a
 * note's `sharedWithLabels`. Returns `undefined` when there is no one to list,
 * so callers can fall back to their non-shared label.
 *
 * Shows a single name and folds everyone else into a "+ N more" summary (e.g.
 * "Shared with Jess Joules + 2 more"), matching the design mock. Keeping this
 * pure (string in, string out) lets every editor sharing surface share one
 * formatting rule and lets the copy be unit-tested without React.
 */
export const getSharedWithLabel = (labels: string[] | undefined): string | undefined => {
  if (!labels?.length) {
    return undefined;
  }

  const [firstName, ...rest] = labels;

  if (rest.length === 0) {
    return `Shared with ${firstName}`;
  }

  return `Shared with ${firstName} + ${rest.length} more`;
};
